import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import SeoHead from "../components/SeoHead";

const CONTENT = {
  privacy: {
    title: "Privacy Policy",
    body: [
      "ApnaFix respects your privacy. This placeholder policy explains how we collect, use and protect your information when you use our platform.",
      "We collect details you provide while booking a service or registering as a partner — such as name, contact number, address and uploaded photos or documents — strictly to connect you with the right local professional.",
      "We do not sell your personal data. Information is shared only with the assigned professional and our support team to complete your service.",
      "You may request access to or deletion of your data at any time by contacting us.",
    ],
  },
  terms: {
    title: "Terms & Conditions",
    body: [
      "These placeholder terms govern your use of the ApnaFix platform. By booking a service or registering as a partner, you agree to them.",
      "ApnaFix connects customers with independent local service professionals. Pricing shown is indicative; final charges are confirmed based on the actual work.",
      "Partners are responsible for completing jobs professionally and for the accuracy of the verification documents they submit.",
      "ApnaFix is not liable for disputes arising directly between customers and professionals beyond the support we provide.",
    ],
  },
  cancellation: {
    title: "Cancellation Policy",
    body: [
      "This placeholder policy explains how cancellations work on ApnaFix.",
      "You can cancel a booking free of charge before a professional is assigned and on the way.",
      "If a professional has already arrived, a small visit fee may apply to cover their time and travel.",
      "To cancel, use your booking confirmation or contact our support team via WhatsApp.",
    ],
  },
};

export default function LegalPage({ type }) {
  const c = CONTENT[type] || CONTENT.privacy;
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-12">
      <SeoHead title={`${c.title} - ApnaFix`} />
      <Link to="/" className="inline-flex items-center gap-1 text-sm text-slate-500 hover:text-navy mb-4"><ArrowLeft className="w-4 h-4" /> Home</Link>
      <h1 className="font-display text-3xl font-extrabold text-slate-900">{c.title}</h1>
      <p className="mt-2 text-xs text-slate-400">Sample content — to be finalised with legal review before launch.</p>
      <div className="mt-6 space-y-4">
        {c.body.map((p, i) => <p key={i} className="text-slate-600 leading-relaxed">{p}</p>)}
      </div>
    </div>
  );
}
